import React from 'react'
import ScaleLoader from 'react-spinners/ScaleLoader'
import styled from 'styled-components'


const LoaderContainer = styled.div`
dispaly: flex;
justify-content: center;
align-items: center;
z-index: 100;
position: fixed;
left: 50%;
top: 50%;
`

const Loader = ({isFetching}) => {
  return (
    <LoaderContainer>
    <ScaleLoader color="#614e20ff" height={30} loading={isFetching}  size={100} />
    </LoaderContainer>
  )
}

export default Loader